module.exports = __webpack_public_path__ + "static/media/twitter.4ce0e836.svg";